import { DocumentCheckIcon } from '@heroicons/react/16/solid'
import { type FunctionComponent } from 'react'
import { Icn } from 'tailwind-ui'
import { generateImage } from '@/helpers/image'
import { type InboxThreadEventEventableEmailType } from '@/state/entities/inbox/inbox.types'

interface PassedProps {
  attachment: InboxThreadEventEventableEmailType['attachments'][number]
}

const AttachmentIcon: FunctionComponent<
  PassedProps & React.HTMLAttributes<HTMLDivElement>
> = ({ attachment, ...rest }) => {
  console.log({ attachment })
  if (attachment.content_type.includes('image/')) {
    return (
      <img
        className="rounded-md bg-gray-200 dark:bg-gray-700"
        objectFit="cover"
        src={generateImage(attachment.url, 'tiny')}
        {...rest}
      />
    )
  }

  return (
    <div
      className="flex justify-center items-center bg-gray-200 dark:bg-gray-700 rounded-md"
      {...rest}
    >
      <Icn icon={DocumentCheckIcon} />
    </div>
  )
}

export default AttachmentIcon
